// extracted by mini-css-extract-plugin
export default {"reportsInnerWrapper":"styles_reportsInnerWrapper__+xoPd","reportsLayout":"styles_reportsLayout__c3j9x","reportsContent":"styles_reportsContent__4LpNY"};